import { AnimatePresence } from "framer-motion";
import { useBookingForm, todayPlusOne } from "@/hooks/use-booking-form";
import BookingStep1 from "@/components/booking/BookingStep1";
import BookingStep2 from "@/components/booking/BookingStep2";
import BookingStep3 from "@/components/booking/BookingStep3";
import BookingSuccess from "@/components/booking/BookingSuccess";
import BookingNavButtons from "@/components/booking/BookingNavButtons";
import BookingHeader from "@/components/booking/BookingHeader";

const TOTAL_STEPS = 3;

function renderStep(step, props) {
  if (step === 1) return <BookingStep1 {...props} />;
  if (step === 2) return <BookingStep2 {...props} />;
  return <BookingStep3 {...props} />;
}

export default function BookingForm({ t, lang, prefill }) {
  const {
    step, form, errors, submitting, success, serverError,
    set, next, back, submit, reset,
  } = useBookingForm(t, lang, prefill);

  if (success) {
    return <BookingSuccess t={t} bookingId={success.id} onReset={reset} />;
  }

  const stepLabels = [t.booking.steps.s1, t.booking.steps.s2, t.booking.steps.s3];
  const isLastStep = step === TOTAL_STEPS;
  const stepProps = { t, form, set, errors, minDate: todayPlusOne() };

  return (
    <div className="card-surface p-6 sm:p-10" data-testid="booking-form">
      <BookingHeader t={t} step={step} totalSteps={TOTAL_STEPS} label={stepLabels[step - 1]} />

      <AnimatePresence mode="wait">{renderStep(step, stepProps)}</AnimatePresence>

      {serverError && (
        <div
          className="mt-6 px-4 py-3 rounded-xl bg-[var(--accent)]/10 text-[var(--accent)] text-sm font-medium border border-[var(--accent)]/30"
          data-testid="booking-server-error"
        >
          {serverError}
        </div>
      )}

      <BookingNavButtons
        step={step}
        isLastStep={isLastStep}
        submitting={submitting}
        t={t}
        onBack={back}
        onNext={next}
        onSubmit={submit}
      />
    </div>
  );
}
